import { render, staticRenderFns } from "./ArticleInformationCard.vue?vue&type=template&id=5c64b271&scoped=true"
import script from "./ArticleInformationCard.vue?vue&type=script&lang=js"
export * from "./ArticleInformationCard.vue?vue&type=script&lang=js"
import style0 from "./ArticleInformationCard.vue?vue&type=style&index=0&id=5c64b271&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c64b271",
  null
  
)

export default component.exports